/**
 * Available Role
 */
export enum Role {
    USER = 'USER',
    ADMIN = 'ADMIN',
    VISITOR = 'VISITOR'
}